import React from 'react';
import {
  Container, Row, Col, Spinner,
} from 'react-bootstrap';
import Accordion from 'components/Accordion';
import RadioButton from 'components/DesignSystem/RadioButton';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectFluxAutomaticControlPanelUnicenarioScenario,
  setUnicenarioScenario,
} from 'redux/reducers/fluxAutomaticControlPanelReducer';
import useAutomaticOptions from 'utils/hooks/flux/useAutomaticOptions';

export default function UnicenarioStudy() {
  const dispatch = useDispatch();
  const selectedScenario = useSelector(selectFluxAutomaticControlPanelUnicenarioScenario);
  const { labeledScenarios, isFetching } = useAutomaticOptions();

  const handleSelect = (scenario: string) => {
    dispatch(setUnicenarioScenario(scenario === selectedScenario ? undefined : scenario));
  };

  return (
    <Accordion.Item eventKey="2">
      <Accordion.Header>Estudo Automático</Accordion.Header>
      <Accordion.Body>
        {isFetching && <Spinner animation="border" />}
        {!isFetching && labeledScenarios.map((group, index) => (
          <Accordion key={group.label} defaultActiveKey={index === 0 ? group.label : undefined}>
            <Accordion.Item eventKey={group.label}>
              <Accordion.Header>{group.label}</Accordion.Header>
              <Accordion.Body>
                <Container>
                  <Row md={2}>
                    {group.scenarios.map((scenario) => (
                      <Col key={scenario.scenario}>
                        <RadioButton
                          name="unicenario-scenario"
                          label={scenario.scenario}
                          disabled={!scenario.selectable}
                          checked={selectedScenario === scenario.scenario}
                          onChange={() => handleSelect(scenario.scenario)}
                        />
                      </Col>
                    ))}
                  </Row>
                </Container>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        ))}
      </Accordion.Body>
    </Accordion.Item>
  );
}
